// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginationSection_container__SMYkx","btnContainer":"PaginationSection_btnContainer__VOJjH","btnContainerSelected":"PaginationSection_btnContainerSelected__hQjD9"};